import {FIT_TYPE_LIST, LOGO_IMAGE_DETAIL, LOGO_POSITION_OPTIONS_LIST} from "../../shopify/constants/shopify.constant";
import {POSITION_OPTIONS_LIST} from "../../design/constants/design.constant";

export const DATA_LIMIT = 10;

export const STAGE_ZOOM_STEP = 0.025;
export const KEY_PREFIX = {
    CARD: 'card',
    LAYER: 'layer',
    BACKGROUND: 'background',
    IMAGE: 'image',
    TEXT: 'text',
    COMMON_TEXT: 'common-text',
}


export const MEDIA_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "dimensionName", label: "Type", cssClass: ''},
    {attribute: "size", label: "Size", cssClass: ''},
    /*{attribute: "image", label: "Image", cssClass: ''},*/
];


export const MEDIA_INPUT_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "type", label: "Type", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "image", label: "Image", type: 'text', group: 'detail', cssClass: ''},
];

export const MEDIA_IMAGE_INPUT_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "dimensionType", label: "Dimension Type", type: 'select', group: 'detail', cssClass: '', options: []},
];

export const DEFAULT_MEDIA_IMAGE_SETTINGS: any = {
    productImages: [],
    background: {
        backgroundColor: "#D1D5DB",
        backgroundColorCodeKey: "300",
        backgroundColorKey: "gray",
        colorType: "solid"
    },
    isRepeatImage: false,
    isBackgroundImage: true,
    size: "100",
    fillPatternOffsetXPercentage: 0,
    fillPatternOffsetYPercentage: 0,
    fillPatternRotation: 0,
    fillPatternRepeat: 'no-repeat',
    /*width: 1800,
    height: 1000,*/
    scale: 1,
    width: 1080,
    height: 1080,
    position: 'left-top',
    containerClass: 'featured-image-stage-container',
    product: {
        fit: "height",
        size: 50,
        fillPatternOffsetXPercentage: 0,
        fillPatternOffsetYPercentage: 0,
        fillPatternRotation: 0,
    },
    ...LOGO_IMAGE_DETAIL,
}

export const DEFAULT_PINTEREST_IMAGE_SETTINGS: any = {
    productImages: [],
    background: {
        backgroundColor: "#D1D5DB",
        backgroundColorCodeKey: "300",
        backgroundColorKey: "gray",
        colorType: "solid"
    },
    isRepeatImage: false,
    isBackgroundImage: true,
    size: 100,
    fillPatternOffsetXPercentage: 0,
    fillPatternOffsetYPercentage: 0,
    fillPatternRotation: 0,
    fillPatternRepeat: 'no-repeat',
    /*width: 1800,
    height: 1000,*/
    scale: 1,
    width: 1000,
    height: 1500,
    position: 'left-top',
    containerClass: 'featured-image-stage-container',
    product: {
        fit: "height",
        size: 50,
        fillPatternOffsetXPercentage: 0,
        fillPatternOffsetYPercentage: 0,
        fillPatternRotation: 0,
    },
    ...LOGO_IMAGE_DETAIL,
}

export const DEFAULT_COLOR_SETUP = {
    backgroundColor: "#D1D5DB",
    backgroundColorCodeKey: "300",
    backgroundColorKey: "gray",
    colorType: "solid"
}

export const DEFAULT_TEXT_SETTINGS = {
    shadowBlur: 0,
    colorType: "solid",
    colorKey: 'teal',
    colorCodeKey: 400,
    fill: '#2DD4BF',
    fontSize: 50,
    shadowOffsetX: 5,
    shadowOffsetY: 5,
    shadowColorKey: 'neutral',
    shadowColor: '#D4D4D4',
    shadowColorCodeKey: 300,
    strokeWidth: 5,
    strokeHexCode: '#525252',
    stroke: '#525252',
    strokeColorKey: 'neutral',
    strokeColorCodeKey: 600,
    lineJoin: 'round',
    hexCode: '#2DD4BF',
    fontFamily: 'Keshia',
    fillAfterStrokeEnabled: true,
    offsetX: 0,
    offsetY: 0,
    offsetXPercentage: 0,
    offsetYPercentage: 0,
    /*width: 1000,
    height: 1000,*/
    align: 'center',
    textBaseline: 'middle',
    background: DEFAULT_COLOR_SETUP
}


export const IMAGE_FIELD_LIST = [
    {attribute: 'size', label: 'Size (%)', type: 'number', readOnly: false, group: 'dimension', default: 100},
    {
        attribute: 'rotation',
        label: 'Rotation Degrees',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'offsetXPercentage',
        label: 'Offset X (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'offsetYPercentage',
        label: 'Offset Y (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'fit',
        label: 'Fit',
        type: 'select',
        readOnly: false,
        group: 'dimension',
        options: FIT_TYPE_LIST,
        default: "height"
    },
    {
        attribute: 'positionType',
        label: 'Position',
        type: 'select',
        readOnly: false,
        group: 'dimension',
        options: POSITION_OPTIONS_LIST,
        default: 'center-center',
    }
];


export const COMMON_IMAGE_POSITION_FIELD_LIST = [
    {
        attribute: 'imageFitType',
        label: 'Image Fit',
        type: 'select',
        readOnly: false,
        group: 'dimension',
        options: FIT_TYPE_LIST,
        default: "height"
    },
    {
        attribute: 'imagePositionType',
        label: 'Image Position',
        type: 'select',
        readOnly: false,
        group: 'dimension',
        options: POSITION_OPTIONS_LIST,
        default: 'center-center',
    }
];
